/**
 * time.ts — Europe/Berlin formatters (D-09).
 *
 * All timestamps are stored as UTC in the DB and transmitted as ISO 8601 UTC strings.
 * Client-side rendering converts to Europe/Berlin for display.
 */

const BERLIN = 'Europe/Berlin';

/** Format a UTC ISO string as a Europe/Berlin date+time (short). */
export function formatBerlin(iso: string | null | undefined): string {
  if (!iso) return '—';
  try {
    return new Intl.DateTimeFormat('de-DE', {
      timeZone: BERLIN,
      dateStyle: 'short',
      timeStyle: 'short',
    }).format(new Date(iso));
  } catch {
    return iso;
  }
}

/** Format a UTC ISO string as a Europe/Berlin time only (HH:mm). */
export function formatTimeBerlin(iso: string | null | undefined): string {
  if (!iso) return '—';
  try {
    return new Intl.DateTimeFormat('de-DE', {
      timeZone: BERLIN,
      timeStyle: 'short',
    }).format(new Date(iso));
  } catch {
    return iso;
  }
}

/** Format a UTC ISO string as Europe/Berlin date only. */
export function formatDateBerlin(iso: string | null | undefined): string {
  if (!iso) return '—';
  try {
    return new Intl.DateTimeFormat('de-DE', {
      timeZone: BERLIN,
      dateStyle: 'medium',
    }).format(new Date(iso));
  } catch {
    return iso;
  }
}

/** Relative time label: "just now", "5 min ago", etc. */
export function relativeTime(iso: string | null | undefined): string {
  if (!iso) return '—';
  try {
    const diff = Date.now() - new Date(iso).getTime();
    const minutes = Math.floor(diff / 60_000);
    if (minutes < 1) return 'just now';
    if (minutes < 60) return `${minutes}m ago`;
    const hours = Math.floor(minutes / 60);
    if (hours < 24) return `${hours}h ago`;
    const days = Math.floor(hours / 24);
    return `${days}d ago`;
  } catch {
    return iso;
  }
}
